






import Vue from 'vue';

export default Vue.extend({
  props: {
    hideWhenNotInView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inView: false
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.inView = true;
          } else if (this.hideWhenNotInView) {
            this.inView = false;
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    const container = this.$refs.inViewContainer as Element;
    if (container) {
      observer.observe(container);
    }

    this.$once('hook:beforeDestroy', () => {
      if (container) {
        observer.unobserve(container);
      }
    });
  }
});
